import { Component, Inject, OnInit } from '@angular/core';
import { MarketplacePackagesApiService, ProductInterface } from '@vendasta/marketplace-packages';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-product-settings',
  templateUrl: './product-settings.component.html',
  styleUrls: ['./product-settings.component.scss'],
})
export class ProductSettingsComponent implements OnInit {
  columnsToDisplay: string[] = ['productName', 'editLink'];
  enabledProducts: ProductInterface[];

  customizeLinkForId: { [key: string]: string } = {
    SM: '/customize/social-marketing/',
    MS: '/customize/listing-builder/',
    RM: '/customize/reputation-management/',
  };

  constructor(
    @Inject('PARTNER_ID') readonly partnerId$: Observable<string>,
    private marketplacePackages: MarketplacePackagesApiService,
  ) {}

  ngOnInit(): void {
    this.partnerId$
      .pipe(
        switchMap((partnerId) =>
          this.marketplacePackages.getMultiProducts({
            partnerId,
            fieldMask: {
              paths: ['productId', 'name'],
            },
            productIds: ['SM', 'MS', 'RM'],
          }),
        ),
        map((resp) => resp.products.map((pc) => pc.product)),
      )
      .subscribe((data) => (this.enabledProducts = data));
  }
}
